 //export const urlServer = process.env.SERVER || 'https://api.ecoideas.app/api/1.0/'; 'https://d2lu5wth5idc9o.cloudfront.net/';
export const urlServerSocket = process.env.SERVER || 'https://api.ecoideas.app/'
//export const urlServerSocket = process.env.SERVER || 'http://localhost:8080/';
export const urlServer = process.env.SERVER || `${urlServerSocket}api/1.0/`;
